module.exports = __webpack_public_path__ + "static/img/katun04.742b9a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun04.jpg
// module id = 2ReC
// module chunks = 0